import {Information} from './Information'

export class DetailsWithInformation<T> {
    details: T
    information: Information

    constructor(
        details: T,
        information: Information,
    ) {
        this.details = details
        this.information = information
    }
}
